var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-input-select',{attrs:{"label":_vm.label,"help-danger":_vm.helpDanger,"loading":_vm.jurisdictionsMeta.loading,"options":_vm.jurisdictions,"value":_vm.selectValue},on:{"input":_vm.handleJurisdictionSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }